export default __webpack_public_path__ + "static/media/alert-info.13ec4de8.png";